<template>
  <div>
    <van-icon name="arrow-left"  size="22" @click="$router.go(-1)"/>
  </div>
</template>

<script>
  export default {
    name: "arrow-left",
  }
</script>

<style scoped>

</style>